import { render, staticRenderFns } from "./SaveProjectDialog.vue?vue&type=template&id=29c12a9b&scoped=true"
import script from "./SaveProjectDialog.vue?vue&type=script&lang=js"
export * from "./SaveProjectDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c12a9b",
  null
  
)

export default component.exports